'use client';

import { Vmo2Theme } from './vmo2-theme';

export default Vmo2Theme;
